/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Stage_Api_BadgeInputs */

const en_byoa_stage_api_badge = /** @type {(inputs: Byoa_Stage_Api_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API key`)
};

const id_byoa_stage_api_badge = /** @type {(inputs: Byoa_Stage_Api_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API`)
};

/**
* | output |
* | --- |
* | "API key" |
*
* @param {Byoa_Stage_Api_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_stage_api_badge = /** @type {((inputs?: Byoa_Stage_Api_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Stage_Api_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_stage_api_badge(inputs)
	return en_byoa_stage_api_badge(inputs)
});